import UpdatePhotoModal from '../components/UpdatePhotoModal';
import api from './api';
import imageCompression from 'browser-image-compression';

const documentService = {
    // Subir documentos
    async uploadDocuments(files, inspectionId, onProgress) {
        try {
            const compressedFiles = await this.compressFiles(files);
            
            // Obtener URLs prefirmadas
            const uploadUrls = await this.getUploadUrls(compressedFiles, inspectionId);
            
            // Subir archivos a S3
            const uploadedFiles = await this.uploadToS3(compressedFiles, uploadUrls, onProgress);
            
            return uploadedFiles;
        } catch (error) {
            console.error('Error uploading documents:', error);
            throw error;
        }
    },

    // Comprimir archivos
    async compressFiles(files) {
        const compressedFiles = [];
        
        for (const file of files) {
            if (file.type.startsWith('image/')) {
                // Comprimir imágenes
                const compressedFile = await imageCompression(file, {
                    maxSizeMB: 2,
                    maxWidthOrHeight: 1920,
                    useWebWorker: true
                });
                compressedFiles.push(compressedFile);
            } else {
                // Para otros archivos, usar el archivo original
                compressedFiles.push(file);
            }
        }
        
        return compressedFiles;
    },

    // Obtener URLs prefirmadas para subir documentos
    async getUploadUrls(files, inspectionId) {
        try {
            const fileData = files.map(file => ({
                name: file.name,
                type: file.type,
                size: file.size
            }));

            const response = await api.post(`/inspections/${inspectionId}/documents/upload-urls`, {
                inspectionId,
                documents: fileData
            });

            return response.data.uploadUrls;
        } catch (error) {
            console.error('Error getting upload URLs:', error);
            throw error;
        }
    },

    // Subir archivos a S3
    async uploadToS3(files, uploadUrls, onProgress) {

        const uploadPromises = files.map(async (file, index) => {
            const uploadUrl = uploadUrls[index];
            
            const response = await fetch(uploadUrl.url, {
                method: 'PUT',
                body: file,
                headers: {
                    'Content-Type': file.type
                }
            });

            if (!response.ok) {
                throw new Error(`Error uploading file: ${file.name}`);
            }

            return {
                id: uploadUrl.id,
                key: uploadUrl.s3Key,
                name: file.name,
                size: uploadUrl.fileSize,
                type: uploadUrl.fileType,
            };
        });

        const results = await Promise.all(uploadPromises);
        
        if (onProgress) {
            onProgress(100);
        }

        return results;
    },

    // Obtener URL de descarga individual
    async getDownloadUrl(inspectionId, attachments) {
        try {
            const response = await api.post(`/inspections/${inspectionId}/documents/download-urls`, {
                inspectionId,
                documents: attachments.map(attachment => ({
                    key: attachment.id,
                    name: attachment.name
                }))
            });
            return response.data.downloadUrls;
        } catch (error) {
            console.error('Error getting download URL:', error);
            throw error;
        }
    }
};

export default documentService;